import { CalendarDays, LogOut, LogIn } from "lucide-react";
import { fmtDate, dot } from "../lib/fmt";

export default function Header({ data, date, setDate, lastRefresh, onLogout, onLogin }) {
  const isToday = data.date === data.today;
  const me = data.me;
  return (
    <header data-testid="app-header" className="rounded-b-[28px] bg-brand px-4 pb-5 pt-4 text-white sm:rounded-[28px] sm:px-7 sm:pt-6">
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <div data-testid="brand-logo" className="flex shrink-0 flex-col rounded-2xl bg-white px-3 py-1.5 leading-none text-brand">
            <span className="text-[9px] font-bold uppercase tracking-[0.2em] text-brand-deep">Cimol</span>
            <span className="text-base font-extrabold">Bojot AA</span>
          </div>
          <div className="min-w-0">
            <h1 className="truncate text-xl font-extrabold leading-tight sm:text-2xl">Daily Tracker</h1>
            <p data-testid="deadline-text" className="text-xs text-white/85">Batas isi {dot(data.settings.deadline)} WIB</p>
          </div>
        </div>
        <div className="flex shrink-0 flex-col items-end gap-1.5">
          {me ? (
            <button data-testid="logout-button" onClick={onLogout} className="inline-flex min-h-[40px] items-center gap-1.5 rounded-full bg-white/15 px-3.5 text-xs font-bold hover:bg-white/25">
              <LogOut size={14} /> Keluar
            </button>
          ) : (
            <button data-testid="header-login-button" onClick={onLogin} className="inline-flex min-h-[40px] items-center gap-1.5 rounded-full bg-white px-3.5 text-xs font-bold text-brand">
              <LogIn size={14} /> Masuk
            </button>
          )}
          <div data-testid="live-indicator" className="flex items-center gap-1.5 text-[11px] text-white/85">
            <span className="live-dot h-2 w-2 rounded-full bg-white" /> LIVE · {lastRefresh}
          </div>
        </div>
      </div>
      <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          {me && <div data-testid="header-user" className="text-xs text-white/80">Halo, <b className="text-white">{me.name}</b> · {me.role}</div>}
          {!me && <div className="text-xs text-white/80">Mode lihat saja</div>}
          <div data-testid="header-date" className="text-lg font-extrabold sm:text-xl">
            {fmtDate(data.date)} {isToday && <span className="font-semibold text-white/80">(hari ini)</span>}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <label className="relative inline-flex min-h-[44px] cursor-pointer items-center gap-2 rounded-full bg-white/15 px-4 text-sm font-bold hover:bg-white/25">
            <CalendarDays size={16} /> Pilih tanggal
            <input data-testid="date-picker" type="date" max={data.today} value={date || data.today}
              onChange={(e) => e.target.value && setDate(e.target.value >= data.today ? null : e.target.value)}
              className="absolute inset-0 cursor-pointer opacity-0" />
          </label>
          {!isToday && (
            <button data-testid="today-button" onClick={() => setDate(null)} className="min-h-[44px] rounded-full bg-white px-4 text-sm font-bold text-brand">
              Hari ini
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
